exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".payment__credit-cards .row{margin-left:0}.payment__credit-cards .row .col-md-12{padding-left:0}.payment__credit-cards .row .col-md-6{padding-left:0}.payment__credit-cards #cardName{width:100%}.payment__credit-cards #cardName input{border:1px solid #ccc;padding:10px 14px !important;height:38px;font-size:1em}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/scss/component/payment-form.scss
// module id = 2169
// module chunks = 3